import { colorsMatrix, StyledFlex } from '@dreryk/react-components';

import { translationKeys } from '../translations';
import { useAiAssistantRecordingGlobalState } from '../shared/useAiAssistantRecordingGlobalState';
import { CheckCircleIcon } from '../icons/CheckCircleIcon';
import { ChevronRightIcon } from '../icons/ChevronRightIcon';

import { StyledLink } from './AiAssistantMainMenuTileItemFinal.styled';
import { AiAssistantMainMenuTileItemContainer } from './AiAssistantMainMenuTileItemContainer';
import { AiAssistantMainMenuTileItemRecordAgainModalOpener } from './AiAssistantMainMenuTileItemRecordAgainModal.opener';
import { TileItemSecondaryButton } from './TileItemSecondaryButton';

const t = translationKeys.mainMenuTileItem;

type AiAssistantMainMenuTileItemFinalProps = {
   onShowNote: VoidFunction;
};

export const AiAssistantMainMenuTileItemFinal = (props: AiAssistantMainMenuTileItemFinalProps): JSX.Element => {
   const { reset } = useAiAssistantRecordingGlobalState();

   return (
      <AiAssistantMainMenuTileItemContainer icon={<CheckCircleIcon />} backgroundColor={colorsMatrix.green.lightest}>
         <StyledFlex direction={'column'} gap={8} alignItems={'center'} width={'100%'}>
            <CheckCircleIcon />
            <StyledFlex direction={'column'} gap={8} alignItems={'center'} width={'100%'}>
               <TileItemSecondaryButton label={t.showNote} testId={'showNote'} onClick={props.onShowNote} />
               <StyledFlex alignItems={'center'} gap={4}>
                  <AiAssistantMainMenuTileItemRecordAgainModalOpener onConfirm={reset}>
                     {({ openModal }) => (
                        <StyledLink label={t.recordAgain} onClick={openModal} testId={'recordAgain'} />
                     )}
                  </AiAssistantMainMenuTileItemRecordAgainModalOpener>
                  <ChevronRightIcon />
               </StyledFlex>
            </StyledFlex>
         </StyledFlex>
      </AiAssistantMainMenuTileItemContainer>
   );
};
